import getClassNames from '../style'
import type {
    ClassNames,
    ConfigurationOptions,
    ApplicationState,
} from '../types'

import createState from './createState'

export const initialState: ApplicationState = {
    action: null,
    sourceBase64: '',
    fileName: '',
    sourceHeight: 0,
    sourceWidth: 0,
    frame: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
    },
    portal: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
    },
    emitted: {
        X: 0,
        Y: 0,
        left: 0,
        top: 0,
        width: 0,
        height: 0,
    },
    config: {
        applyButtonLabel: 'Apply',
        cancelButtonLabel: 'Cancel',
        compression: 1,
        framePadding: 3,
        minPortalSize: 50,
        lockAspectRatio: true,
        portalPosition: 'center',
        portalSize: 150,
        outputSize: 0,
        type: 'jpeg',
        maxFileSize: 0,
        allowedTypes: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
    },
}

const state = (
    config: Partial<ConfigurationOptions> = {},
    css: Partial<ClassNames> = {}
) =>
    createState({
        ...initialState,
        config: { ...initialState.config, ...config },
        css: getClassNames(css),
    })

export default state
